import { useContext } from "react";

import AuthenticatedUserContext from "src/contexts/authentication/AuthenticatedUserContext";

/**
 * Reads the current user data from the authentication context.
 *
 * Postconditions: Returns the context's current data, including undefined before a provider
 * supplies it. Loading and error state are not returned by this hook.
 */
const useCurrentUser = () => {
    const { data } = useContext(AuthenticatedUserContext);
    return data;
};

export default useCurrentUser;
